import { FgInspectionDTO } from "./fg-inspection.dto";
import { FgInspection } from '../entities/fg-inspection.entity';
import { EntityRepository } from "typeorm";
import { FgInspectionSamplesDTO } from "./fg-inspection-samples.dto";
import { FgInspectionSamples } from "../entities/fg-inspection-samples.entity";

export class FgInspectionAdapter{

    public convertDtoToEntity(dto: FgInspectionDTO): FgInspection{
       try{
        const entity = new FgInspection;
        entity.saleOrderId = dto.saleOrderId;
        entity.saleOrderItemId = dto.saleOrderItemId;
        entity.lotNumber = dto.lotNumber
        entity.section = dto.section
        entity.date = dto.date
        entity.isActive = dto.isActive == undefined ? true: dto.isActive;
        if(dto.fgInspectionId){
            entity.fgInspectionId = dto.fgInspectionId;
            entity.updatedAt = dto.updatedAt;
            entity.updatedUser = dto.updatedUser;
        }else{
            entity.isActive = true;
            entity.createdAt = dto.createdAt;
            entity.createdUser = dto.createdUser;
        }
        const sampleEntity : FgInspectionSamples[] = [];
        for (const sample of dto.samplesInfo){
            const sampleentity = new FgInspectionSamples()
            sampleentity.sampleNo = sample.sampleNo;
            sampleentity.temperature = sample.temperature;
            sampleentity.fillingWeight = sample.fillingWeight;
            sampleentity.frozenWeight = sample.frozenWeight;
            sampleentity.deglazedWeight = sample.deglazedWeight;
            sampleentity.netWeight = sample.netWeight;
            sampleentity.subSampleWeight = sample.subSampleWeight;
            sampleentity.frozenCount = sample.frozenCount;
            sampleentity.deglazedCount = sample.deglazedCount;
            sampleentity.netCount = sample.netCount;
            sampleentity.totalPieces = sample.totalPieces;
            sampleentity.glazePercent = sample.glazePercent;
            sampleentity.totalOunce = sample.totalOunce;
            sampleentity.cluster = sample.cluster;
            sampleentity.generalAppearance = sample.generalAppearance;
            sampleentity.generalOdour = sample.generalOdour;
            sampleentity.freshness = sample.freshness;
            sampleentity.texture = sample.texture;
            sampleentity.dehydration = sample.dehydration;
            sampleentity.discoloration = sample.discoloration;
            sampleentity.deterioration = sample.deterioration;
            sampleentity.peeling = sample.peeling;
            sampleentity.hangingMeat = sample.hangingMeat;
            sampleentity.blackSpot = sample.blackSpot;
            sampleentity.broken = sample.broken;
            sampleentity.wrongCut = sample.wrongCut;
            sampleentity.shells = sample.shells;
            sampleentity.foreignMatter = sample.foreignMatter;
            sampleentity.uniformityBig = sample.uniformityBig;
            sampleentity.uniformitySmall = sample.uniformitySmall;
            sampleentity.uniformityRatio = sample.uniformityRatio;
            sampleentity.productMetSpec = sample.productMetSpec;
            sampleentity.bestBefore = sample.bestBefore;
            sampleentity.remarks = sample.remarks;
            if(sample?.fgInspectionSampleId){
                sampleentity.fgInspectionSampleId = sample.fgInspectionSampleId;
                sampleentity.updatedUser = sample.updatedUser
            }else{
                sampleentity.createdUser=dto.createdUser
            }
            sampleEntity.push(sampleentity)
        }
        entity.samplesInfo=sampleEntity
         return entity;
    }
    catch(error){
        return error
        
    }

    }

    public convertEntityToDto(entity: FgInspection): FgInspectionDTO{
        const dto = new FgInspectionDTO;
        dto.saleOrderId = entity.saleOrderId;
        dto.saleOrderItemId  = entity.saleOrderItemId;
        dto.lotNumber = entity.lotNumber;
        dto.section = entity.section;
        dto.fgInspectionId = entity.fgInspectionId;
        dto.isActive = entity.isActive;
        dto.updatedAt = entity.updatedAt;
        dto.updatedUser = entity.updatedUser;
        dto.createdAt = entity.createdAt;
        dto.updatedUser = entity.createdUser;
        dto.versionFlag = entity.versionFlag;
        return dto;
    }

    public convertEntityToLabelDto(obj: FgInspection): FgInspectionDTO {
        const dto = new FgInspectionDTO;
        dto.saleOrderId = obj.saleOrderId;
        dto.saleOrderItemId  = obj.saleOrderItemId;
        dto.lotNumber = obj.lotNumber;
        dto.section = obj.section;
        dto.fgInspectionId = obj.fgInspectionId;
        dto.isActive = obj.isActive;
        dto.updatedAt = obj.updatedAt;
        dto.updatedUser = obj.updatedUser;
        dto.createdAt = obj.createdAt;
        dto.updatedUser = obj.createdUser;
        dto.versionFlag = obj.versionFlag;
        const samplesInfo: FgInspectionSamplesDTO[] = [];
        for (const sample of obj.samplesInfo) {
            const sampleentity = new FgInspectionSamplesDTO();
            sampleentity.fgInspectionId = sample.fgInspectionId;
            sampleentity.fgInspectionSampleId = sample.fgInspectionSampleId;
            sampleentity.sampleNo = sample.sampleNo;
            sampleentity.temperature = sample.temperature;
            sampleentity.fillingWeight = sample.fillingWeight;
            sampleentity.frozenWeight = sample.frozenWeight;
            sampleentity.deglazedWeight = sample.deglazedWeight;
            sampleentity.netWeight = sample.netWeight;
            sampleentity.subSampleWeight = sample.subSampleWeight;
            sampleentity.frozenCount = sample.frozenCount;
            sampleentity.deglazedCount = sample.deglazedCount;
            sampleentity.netCount = sample.netCount;
            sampleentity.totalPieces = sample.totalPieces;
            sampleentity.glazePercent = sample.glazePercent;
            sampleentity.totalOunce = sample.totalOunce;
            sampleentity.cluster = sample.cluster;
            sampleentity.generalAppearance = sample.generalAppearance;
            sampleentity.generalOdour = sample.generalOdour;
            sampleentity.freshness = sample.freshness;
            sampleentity.texture = sample.texture;
            sampleentity.dehydration = sample.dehydration;
            sampleentity.discoloration = sample.discoloration;
            sampleentity.deterioration = sample.deterioration;
            sampleentity.peeling = sample.peeling;
            sampleentity.hangingMeat = sample.hangingMeat;
            sampleentity.blackSpot = sample.blackSpot;
            sampleentity.broken = sample.broken;
            sampleentity.wrongCut = sample.wrongCut;
            sampleentity.shells = sample.shells;
            sampleentity.foreignMatter = sample.foreignMatter;
            sampleentity.uniformityBig = sample.uniformityBig;
            sampleentity.uniformitySmall = sample.uniformitySmall;
            sampleentity.uniformityRatio = sample.uniformityRatio;
            sampleentity.productMetSpec = sample.productMetSpec;
            sampleentity.bestBefore = sample.bestBefore;
            sampleentity.remarks = sample.remarks;
            samplesInfo.push(sampleentity);
        }
        dto.samplesInfo = samplesInfo;
        return dto;
    }

}